module.exports = __webpack_public_path__ + "static/media/Partner-LogosDanamon.23d2993b.png";